import React from 'react';
import CreateIconComponent, { CreateIconComponentProps } from '../../SvgIcons/CreateIconComponent';

export type PaperInvitationsIconProps = CreateIconComponentProps;
export const PaperInvitationsIcon: React.FC<PaperInvitationsIconProps> = ({
  title = 'PaperInvitations',
  viewBox = '0 0 24 24',
  ...rest
}) => (
  <CreateIconComponent title={title} viewBox={viewBox} {...rest} fill="none">
    <rect
      width="15.674"
      height="12.245"
      x="6.854"
      y="10.283"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      rx=".817"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M17.674 9.5V3.817A.817.817 0 0 0 16.857 3H2.817A.817.817 0 0 0 2 3.817v10.611c0 .451.366.817.817.817H6"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="m2.5 5 7 5L17 5"
    />
    <path
      fill="currentColor"
      d="M17.577 17.38a.7.7 0 1 0-.985-.994l.985.994Zm-2.575 1.565-.492.498a.7.7 0 0 0 .985 0l-.493-.498Zm-1.59-2.56a.7.7 0 0 0-.985.995l.986-.994Zm-.98 1a.7.7 0 1 0 .976-1.004l-.976 1.004Zm2.57-2.325-.562.418a.7.7 0 0 0 1.122.003l-.56-.42Zm1.592 1.325a.7.7 0 0 0 .981 1l-.98-1Zm-.002 0-2.082 2.063.985.995 2.082-2.063-.985-.994Zm-1.097 2.063-2.082-2.062-.986.994 2.083 2.063.985-.995Zm-2.087-2.067a.688.688 0 0 1-.177-.697l-1.337-.416a2.088 2.088 0 0 0 .538 2.117l.976-1.004Zm-.177-.697a.688.688 0 0 1 .542-.474l-.236-1.38a2.088 2.088 0 0 0-1.643 1.438l1.337.416Zm.542-.474a.688.688 0 0 1 .668.268l1.123-.835a2.088 2.088 0 0 0-2.027-.813l.236 1.38Zm1.789.27a.688.688 0 0 1 .667-.264l.238-1.38a2.088 2.088 0 0 0-2.024.803l1.119.842Zm.667-.264a.688.688 0 0 1 .54.473l1.336-.417a2.088 2.088 0 0 0-1.638-1.435l-.238 1.38Zm.54.473a.688.688 0 0 1-.175.696l.981 1a2.088 2.088 0 0 0 .53-2.113l-1.336.417Z"
    />
  </CreateIconComponent>
);
